export default {
  existing_documents: {
    description:
      'U heeft al de volgende documenten geüpload. Selecteer er een en druk op verzenden, of upload een nieuw document.',
    sides: {
      front: 'Voorzijde',
      back: 'Achterzijde',
    },
    created_at: 'Geüpload: {{date}}',
    expires_at: 'Vervalt: {{date}}',
  },
  document_types: {
    owner_document: 'Identiteitsdocument eigenaar',
    business_document: 'Bedrijfsdocument',
  },
  form: {
    document_type: {
      label: 'Identiteitsbewijs',
      placeholder: 'Selecteer documenttype',
      options: {
        passport: 'Paspoort',
        driver_license: 'Rijbewijs',
        id_card: 'Identiteitskaart',
        residence_permit: 'Verblijfsvergunning',
      },
    },
    front: {
      label: 'Documentvoorzijde',
    },
    back: {
      label: 'Documentachterzijde (optioneel voor sommige documenten)',
    },
    expires_at: {
      label: 'Vervaldatum document',
      placeholder: 'Selecteer vervaldatum',
    },
  },
  buttons: {
    select_file: 'Bestand selecteren',
    next: 'Volgende',
    back: 'Achterzijde',
    send: 'Verzenden',
    upload_new: 'Nieuw document uploaden',
    use_existing: 'Gebruik een geüpload document',
  },
};
